import { render, staticRenderFns } from "./whOrderNoPay.vue?vue&type=template&id=6742a484&scoped=true&"
import script from "./whOrderNoPay.vue?vue&type=script&lang=js&"
export * from "./whOrderNoPay.vue?vue&type=script&lang=js&"
import style0 from "./whOrderNoPay.vue?vue&type=style&index=0&id=6742a484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6742a484",
  null
  
)

export default component.exports